import React, {} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {waterfallSectionInterface} from "../../../../../../interfaces/sqftInterfaces";
import NavWaterfallSegment from "./NavWaterfallSegment";
import {WATERFALL_OVERLAY_TYPE} from "../../../../../../constants";

const NavWaterfallSection = (props) => {
  const {waterfallSectionData, index} = props;

  const waterfallSegmentsData = waterfallSectionData.segments;

  const getTitle = () => {
    switch (waterfallSectionData.type) {
      case WATERFALL_OVERLAY_TYPE.peninsulaUnderwrap:
        return "sqft.navigation.peninsulaUnderwrap.title";
      case WATERFALL_OVERLAY_TYPE.waterfall:
      default:
        return "sqft.navigation.waterfall.title"
    }
  }

  return (
    <div className="mitered-section" >
      <h3 className="content-header">
        {/*${TranslatesProvider.translate("sqft.navigation.mitered.title")}*/}
        <FormattedMessage id={getTitle()}/>
        <span className="text-inCircle">
           {('0' + (index + 1)).slice(-2)}
        </span>
      </h3>
      <div className="mitered-segments">
        {
          waterfallSegmentsData.map((waterfallSegmentData, index) => {
            return <NavWaterfallSegment key={index}
                                        waterfallSegmentData={waterfallSegmentData}
                                        waterfallSectionData={waterfallSectionData}
                                        index={index} />
          })
        }
      </div>
    </div>
  )
};

NavWaterfallSection.propTypes = {
  waterfallSectionData: PropTypes.shape(waterfallSectionInterface),
};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(NavWaterfallSection);
